module.exports = __webpack_public_path__ + "static/media/cathaybk logo.a0fbdc9b.svg";